import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import type { Extension } from '@/stores/extension/api'
import { isWhitelistError } from '@/utils/api/whitelist'

export async function loadExtensions() {
  try {
    const url = withPbx('extensions')

    const { data } = await http.get<Extension[]>(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export type UpdatedExtensions = {
  updated: number[]
  failed: {
    entityId: number
    errors: { preference: string; reason: string }[]
  }[]
}

export async function updateExtensions(inputData: {
  extensionType: string
  extensionIds: number[]
  preferences: {
    name: string
    value: any
  }[]
}) {
  try {
    const url = withPbx('extensions')

    const { data } = await http.patch<Extension[] | UpdatedExtensions>(
      url,
      inputData
    )

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function deleteExtensions(extensionIds: number[]) {
  try {
    const url = withPbx('extensions')

    const { data } = await http.delete(url, { params: { extensionIds } })

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
